import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

import tcIcon from '../../../theme/assets/other/tc_crypto_tc_icon.png';
import CabinetHello from "../../_UI/cabinetHello";
import {useSelector} from "react-redux";
import {formatWithSpaces} from "../../../helpers/formatSpace";


const CabinetPreSaleMain = () => {
    const { t } = useTranslation();

    const preSaleMain = useSelector(store => store.cabinet.preSaleMainStatus);
    const userData = useSelector(store => store.cabinet.userData);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.posWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.contentWrap} ${Styles.perspective3d}`}>
                    <div className={`${Styles.contentBox} ${Styles.border3dOuter} ${Styles.rotate3dLeft}`}>
                        <div className={`${Styles.balanceWrap}`}>
                            <div className={`${Styles.balanceIcon}`}>
                                <img src={tcIcon} alt="$TC"/>
                            </div>
                            <div className={`${Styles.balanceContent}`}>
                                <div className={`${Styles.balanceName}`}>{t('Ваш баланс')}:</div>
                                <div className={`${Styles.balanceValue}`}>{userData?.user?.token_balance * 1 || 0} ${preSaleMain?.token_sale?.token_code || ''}</div>
                            </div>
                        </div>
                        <div className={`${Styles.detailsWrap}`}>
                            <div className={`${Styles.detailsTitle}`}>{t('О токене')} ${preSaleMain?.token_sale?.token_code || ''}</div>
                            <div className={`${Styles.detailsBox}`}>
                                <div className={`${Styles.detailsBoxRow}`}>
                                    <div className={`${Styles.detailsBoxRowName}`}>{t('Название')}</div>
                                    <div className={`${Styles.detailsBoxRowValue}`}>{preSaleMain?.token_sale?.name || ''}</div>
                                </div>
                                <div className={`${Styles.detailsBoxRow}`}>
                                    <div className={`${Styles.detailsBoxRowName}`}>{t('Тикер')}</div>
                                    <div className={`${Styles.detailsBoxRowValue}`}>${preSaleMain?.token_sale?.token_code || ''}</div>
                                </div>
                                <div className={`${Styles.detailsBoxRow}`}>
                                    <div className={`${Styles.detailsBoxRowName}`}>{t('Сеть')}</div>
                                    <div className={`${Styles.detailsBoxRowValue}`}>{preSaleMain?.token_sale?.network || ''}</div>
                                </div>
                                <div className={`${Styles.detailsBoxRow}`}>
                                    <div className={`${Styles.detailsBoxRowName}`}>{t('Всего токенов')}</div>
                                    <div className={`${Styles.detailsBoxRowValue}`}>{preSaleMain?.token_sale?.total_supply ? formatWithSpaces(preSaleMain?.token_sale?.total_supply) : ''} ${preSaleMain?.token_sale?.token_code || ''}</div>
                                </div>
                                <div className={`${Styles.detailsBoxRow}`}>
                                    <div className={`${Styles.detailsBoxRowName}`}>{t('Тип продажи')}</div>
                                    <div className={`${Styles.detailsBoxRowValue}`}>Pre-sale</div>
                                </div>
                                <div className={`${Styles.detailsBoxRow}`}>
                                    <div className={`${Styles.detailsBoxRowName}`}>{t('Метод оплаты')}</div>
                                    <div className={`${Styles.detailsBoxRowValue}`}>USDT</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${Styles.noteWrap}`}>
                    <CabinetHello
                        title={t('Добро пожаловать в pre-sale time capsule!')}
                        description={t('Здесь будет вы можете купить токены проекта и стать частью цифровой вселенной!')}
                    />
                </div>
            </div>
        </section>
    );
};

export default CabinetPreSaleMain;